import { Dropdown, Icon } from '../../../ui';
import { useAuth } from '../../../hooks/useAuth';
import { StyledProfile } from './style';
import { MenuProps } from 'antd/es/menu';
import { useIntl } from 'react-intl';
import useQueryApiClient from 'utils/useQueryApiClient';
import { FarmData } from 'types/FarmData';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../../config/config';


export const Profile = () => {
  const { user, logout } = useAuth();
  const intl = useIntl();
  const { refetchUser, farms } = useAuth();
  const navigate = useNavigate();

  const { appendData } = useQueryApiClient({
    request: {
      url: `/api/v2/user/farm-change/:id`,
      method: 'PATCH',
    },
    onSuccess: (response) => {
      refetchUser();
      navigate(routes.admin.adminBusiness);
    },
  });

  const handleMenuClick: MenuProps['onClick'] = (e) => {
    switch (e.key) {
      case 'logout':
        logout();
        break;
      default:
        appendData({}, { id: e.key });
    }
  };

  const dropdownItems: MenuProps['items'] = [
    ...farms.map((farm: FarmData) => ({
      label: farm.brand ?? farm.name,
      key: `${farm.id}`,
    })),
    {
      label: intl.formatMessage({ id: 'general.logout' }),
      key: 'logout',
    },
  ];

  const menuProps = {
    items: dropdownItems,
    onClick: handleMenuClick,
  };

  return (
    <StyledProfile>
      <Dropdown menu={menuProps}>
        <div className={'content'}>
          <div className={'profile-icon'}>
            <Icon name={'admin/admin-profile'} />
          </div>
          <div className={'info'}>
            <div className={'farm-name'}>{user?.farmName}</div>
            <div
              className={'contact-name'}
            >{`${user?.name} ${user?.surname}`}</div>
            <div className={'role'}>{user?.role}</div>
          </div>
          <div className={'dropdown'}>
            <Icon name={'admin/admin-profile-arrow-down'} />
          </div>
        </div>
      </Dropdown>
    </StyledProfile>
  );
};
